<template>
  <v-app>
    <v-main>
      <v-btn icon large @click="closeWebView">
        <v-icon>far fa-times</v-icon>
      </v-btn>
      <v-row class="pa-12 ma-0 align-start">
        <v-col cols="12" sm="12" md="8" lg="6">
          <h2 class="text-center mb-4">ผลการทำแบบทดสอบ</h2>
          <v-skeleton-loader
            class="mb-6"
            style="margin: 0 auto"
            type="image, article"
            v-if="showSkeleton"
          ></v-skeleton-loader>
          <v-slide-y-transition>
            <div v-if="summaryResult != null">
              <div class="box-score">
                <h1 class="text-center">
                  <span
                    class="green--text"
                    v-text="summaryResult.score.score || 0"
                  ></span>
                  /
                  <span v-text="summaryResult.maxScore || 0"></span>
                  <span class="ml-3">คะแนน</span>
                </h1>

                <h3 class="text-center">( {{ percentage.toFixed(2) }}% )</h3>
              </div>

              <!-- <p class="text-center subtitle mb-6">
                ทำแบบทดสอบ
                <span class="font-weight-bold">{{
                  summaryResult.scoreHistory.length
                }}</span>
                ครั้ง
              </p> -->

              <!-- <div class="text-center my-4" v-if="hasHistory">
                <v-btn
                  width="220"
                  v-if="!showHistory"
                  color="primary"
                  text
                  @click="showHistory = true"
                  outlined
                >
                  <v-icon left>far fa-history</v-icon>ประวัติการทำแบบทดสอบ
                </v-btn>
              </div> -->

              <!-- <v-expand-transition>
                <div class="ma-4" v-show="showHistory">
                  <div
                    class="d-flex mb-2 align-center"
                    v-for="(item, idx) of summaryResult.scoreHistory || []"
                    :key="`try_${idx}`"
                  >
                    <div class="flex-shrink-1" style="width: 80px">
                      ครั้งที่ {{ summaryResult.scoreHistory.length - idx }}
                    </div>
                    <div class="flex-grow-1">
                      <v-progress-linear
                        rounded
                        :color="
                          item.percentScore == 0
                            ? 'red lighten-2'
                            : 'green lighten-2'
                        "
                        height="24"
                        :value="item.percentScore"
                        reactive
                        striped
                      >
                        <template v-slot="{ value }">
                          <strong>{{ value.toFixed(2) }}%</strong>
                        </template>
                      </v-progress-linear>
                    </div>
                  </div>
                </div>
              </v-expand-transition> -->

              <div class="text-center my-4" v-if="summaryResult.showAnswer">
                <v-btn
                  v-show="
                    summaryResult != null && summaryResult.showAnswer == true
                  "
                  color="primary"
                  @click="goExam(true)"
                  width="220"
                  depressed
                >ดูเฉลย</v-btn>
                <v-btn
                  v-show="
                    summaryResult != null && summaryResult.showAnswer == false
                  "
                  color="primary"
                  @click="goExam(false)"
                  width="220"
                  depressed
                  >กลับไปดูแบบทดสอบ</v-btn
                >
              </div>
              <div class="text-center my-4" v-if="summaryResult">
                <v-btn
                  v-show="summaryResult != null"
                  color="error"
                  @click="closeWebView"
                  width="220"
                  depressed
                >กลับสู่คอร์สเรียน</v-btn>
              </div>
            </div>
          </v-slide-y-transition>
        </v-col>
      </v-row>
      <v-dialog v-model="connectionErr" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{errorTitle}}</v-card-title>
          <v-card-text>{{errorDetail}}</v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2"
            color="success"
            dark
            @click="confirmRetry"
            >ตกลง</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    summaryResult: null,
    showSkeleton: true,
    doProcess: true,
    processMsg: "",
    showHistory: false,
    ticket: null,
    token: null,
    connectionErr: false,
    errorTitle: "",
    errorDetail: "",
    finishExamByDetail: "",
    endPublishDate: null

  }),
  mounted() {
    this.showHistory = false;
    
    let ticketDetail = this.$store.getters.getTicket;

    this.token = ticketDetail.token || this.$route.query.token;
    this.ticket = ticketDetail.ticket || this.$route.params.id;

    if (!ticketDetail.ticket) {
      let ticketDetail = {
        ticket: this.ticket,
        token: this.token,
      };
      this.$store.commit("setTicket", ticketDetail);
    }

    // const token = this.$route.query.token;
    if (this.token != null) {
      this.$store.commit("setToken", this.token);
    }
    this.finishExamByDetail = this.$store.getters.getFinishExamBy;
    this.endPublishDate = this.$store.getters.getEndPublishDate;
    console.log(this.endPublishDate, this.$store.getters.getEndPublishDate)
    this.summary();
  },
  computed: {
    hasHistory() {
      if (
        this.summaryResult != null &&
        this.summaryResult.scoreHistory != null &&
        this.summaryResult.scoreHistory.length > 0
      ) {
        return true;
      }
      return false;
    },
    percentage() {
      if (this.summaryResult != null) {
        return this.summaryResult.score.percentScore || 0;
      }
      return 0;
    },
  },
  methods: {
    goExam(isShowCorrect) {
      this.$store.commit("setShowCorrect", isShowCorrect);
      // this.$router.replace({
      //   name: "examNoParam",
      //   params: {
      //     id: this.$route.params.id,
      //   },
      //   query: {
      //     token: this.$store.state.token,
      //   },
      // });
      this.$router.replace({
        name: "examNoParam"
      });
    },
    renderState(data) {
      this.summaryResult = data;
      // if (
      //   this.summaryResult.scoreHistory != null &&
      //   this.summaryResult.scoreHistory.length > 0
      // ) {
      //   for (const item of this.summaryResult.scoreHistory) {
      //     item.percentage = (item.score * 100) / item.maxScore;
      //     if (isNaN(item.percentage)) item.percentage = 0;
      //   }
      // }
      this.showSkeleton = false;
    },
    summary() {
      this.showHistory = false;
      const ticket = this.ticket;
      let service = `${this.$store.state.api}/summaryExam`;
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      let data = {
        ticket: ticket,
        closedBy: "user",
        finishExamBy: this.finishExamByDetail || null,
        endPublishDate: this.endPublishDate || 0
      };
      console.log(data, this.endPublishDate)
      this.$http
        .post(service, data, config)
        .then((resp) => {
          // console.log(resp);

          if (resp.status == 200 && resp.data.status == true) {
            this.renderState(resp.data.result);
          } else {
            // summary err
            // alert(resp.data.message);
            this.onSummaryError(true)
          }
        })
        .catch((err) => {
          // summary err
          console.log(err);
          if(err.response){
            this.onSummaryError(true)
          } else {
            this.onSummaryError(false)
          }
        })
        .finally(() => {
          this.doProcess = false;
        });
    },
    closeWebView() {
      // this.goExam(false);
      if (typeof closeExam !== "undefined" && typeof closeExam !== null) {
        closeExam.postMessage("true");
      } else {
        console.debug("not running inside a Flutter webview");
        window.opener.postMessage("close", "*");
        window.close();
      }
    },
    onSummaryError(fromCatch) {
      if(fromCatch){
        this.errorTitle = "เกิดข้อผิดพลาดบางประการ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionErr = true
      } else {
        this.errorTitle = "เกิดปัญหาการเชื่อมต่อ"
        this.errorDetail = "โปรดลองใหม่อีกครั้ง"
        this.connectionErr = true
      }
    },
    confirmRetry(){
      this.errorTitle = ""
      this.errorDetail = ""
      this.connectionErr = false
      this.$router.replace({
        name: "examNoParam"
      });
      // this.summary()
    }
  },
};
</script>

<style lang="scss" scoped>
.box-score {
  padding: 24px;
  width: 400px;
  max-width: 100%;
  margin: 32px auto;
  background: #f5f5f5;
  border-radius: 8px;
}

.row {
  height: 100%;
  background: #f5f5f5;
}

.col-12 {
  margin: 0 auto;
  padding: 32px;
  position: relative;
  background: #ffffff;
  border-radius: 8px;
}
.v-btn--icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>